module.exports = __webpack_public_path__ + "static/img/acne-01_a.ecf9a49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/acne-01_a.jpg
// module id = 242
// module chunks = 1